// @flow

export default {
  TRUNCATE_MRTA_PRODUCT_CODE: 'TMRTA',
  IPROTECT5_PRODUCT_NAME: 'iProtect5',
  IINVEST_PRODUCT_NAME: 'iInvest',
}
